import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsbEnum } from "@/utils/indicatorsEsb";
import { ResumeIndicatorB6Data } from "@/services/esus/indicator/esb/b6/getResumeIndicatorB6";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsbB6ResumeProps = {
	resume: ResumeIndicatorB6Data;
};

export function IndicatorEsbB6Resume({ resume }: Readonly<IndicatorEsbB6ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalAtraumaticRestorativeTreatmentProcedures,
		resume.totalProcedures
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de procedimentos restauradores"
					value={resume.totalProcedures.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de procedimentos restauradores"
							message="Quantidade de procedimentos restauradores realizados no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de procedimentos TRA"
					value={resume.totalAtraumaticRestorativeTreatmentProcedures.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de procedimentos TRA"
							message="Quantidade de procedimentos de tratamento restaurador atraumático (TRA) realizados no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Outros procedimentos restauradores"
					value={(
						resume.totalProcedures -
						resume.totalAtraumaticRestorativeTreatmentProcedures
					).toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Outros Procedimentos restauradores"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de procedimentos restauradores desconsiderando <br />
								o procedimento de tratamento restaurador atraumático(TRA) <br />
								realizados no período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Classificação"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsbEnum.B6,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de procedimentos de tratamento restaurador atraumático
								(TRA) em <br />
								relação ao total de procedimentos restauradores realizados no
								período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
